import React, { useState, useEffect } from "react";
import { Select, Radio, Tag, Button, Form } from "antd";

const timeOptions = [
  "Not setting a time",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
];
const weekOptions = [
  { label: "Week 1", value: 1 },
  { label: "Week 2", value: 2 },
];
const segmentOptions = [
  { label: "Monday, Tuesday", value: "Monday Tuesday" },
  { label: "Wednesday, Thursday", value: "Wednesday Thursday" },
  { label: "Friday, Saturday, Sunday", value: "Friday Saturday Sunday" },
];
const responsibleOptions = [
  { label: "PickUp", value: "pick_up" },
  { label: "DropOff", value: "drop_off" },
];
const defaultTimes = {
  pick_up: "08:00",
  drop_off: "16:00",
};

const AlternateWeeks = (props) => {
  // console.log("AlternateWeeks props", props);
  const {
    activeComboId,
    activeChildId,
    parentCombinations,
    parentCombinationsV2,
    setParentCombinationsV2,
    sameScheduleForAll,
    index,
    modified,
  } = props;
  const parentCombo = parentCombinationsV2.find(
    (combo) =>
      String(combo.coparent_combination_id || combo?.id) ===
      String(activeComboId)
  );
  let targetChild;
  if (!sameScheduleForAll) {
    targetChild = parentCombo?.children?.find(
      (child) => String(child.child_id || child?.id) === String(activeChildId)
    );
  } else {
    targetChild = parentCombo?.children[0];
  }

  const parent1 = parentCombo?.parent1;
  const parent2 = parentCombo?.parent2;

  const [form] = Form.useForm();
  const [showCustom, setShowCustom] = useState(false);
  const [customHour, setCustomHour] = useState();
  const [customMinute, setCustomMinute] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [weeks, setWeeks] = useState([]);

  // Week state for this tab
  const [weekData, setWeekData] = useState({
    week_number: index === 0 ? 1 : 2,
    [`parent${index === 0 ? 1 : 2}_id`]:
      index === 0 ? parent1?.user_id : parent2?.user_id,
    assigned_to: index === 0 ? "parent1" : "parent2",
    responsible_for: undefined,
    pickup_time: undefined,
    dropoff_time: undefined,
  });

  // Update weekData and parentCombinationsV2 on any field change
  const applyUpdateToWeeks = (weeks = [], update) => {
    // Normalize weeks into flat array if needed
    let normalizedWeeks = [];

    weeks.forEach((w) => {
      if (w.week_number) {
        // already flat
        normalizedWeeks.push(w);
      } else {
        // legacy format like { week_number1: { ... }, week_number2: { ... } }
        Object.keys(w).forEach((key) => {
          normalizedWeeks.push(w[key]);
        });
      }
    });

    // Find if the week already exists
    const existingIndex = normalizedWeeks.findIndex(
      (w) => w.week_number === update.week_number
    );

    if (existingIndex > -1) {
      // Update only values (don’t overwrite whole object)
      normalizedWeeks[existingIndex] = {
        ...normalizedWeeks[existingIndex],
        responsible_for: update.responsible_for,
        assigned_to: update.assigned_to,
        pickup_time: update.pickup_time || null,
        dropoff_time: update.dropoff_time || null,
      };
    } else {
      // Insert new week
      normalizedWeeks.push(update);
    }

    return normalizedWeeks;
  };

  const onValuesChange = (changed, all) => {
    let update = {
      week_number: index === 0 ? 1 : 2,
      [`parent${index === 0 ? 1 : 2}_id`]:
        index === 0 ? parent1?.user_id || null : parent2?.user_id || null,
      assigned_to: index === 0 ? "parent1" : "parent2",
      responsible_for: all.responsible_for || null,
      pickup_time:
        all.responsible_for === "pick_up"
          ? all.time === "Not setting a time"
            ? null
            : all.time
          : null,
      dropoff_time:
        all.responsible_for === "drop_off"
          ? all.time === "Not setting a time"
            ? null
            : all.time
          : null,
    };
    setWeekData(update);
    setSelectedTime(all.time);
    setWeeks((prev) => {
      let existing = Array.isArray(prev)
        ? prev.filter((w) => w.week_number !== update.week_number)
        : [];
      return [...existing, update];
    });

    if (typeof setParentCombinationsV2 === "function") {
      setParentCombinationsV2((prev) =>
        prev.map((combo) => {
          if (
            String(combo?.id || combo?.coparent_combination_id) !==
            String(activeComboId)
          ) {
            return combo; // not the active combo
          }

          // ✅ use your targetChild selection logic
          let targetChild;
          if (sameScheduleForAll) {
            targetChild = combo?.children?.[0]; // always first child
          } else {
            targetChild = combo?.children?.find(
              (child) =>
                String(child?.child_id || child?.id) === String(activeChildId)
            );
          }

          if (!targetChild) return combo; // safety guard

          // Now handle weeks update
          let existingWeeks = Array.isArray(targetChild.weeks)
            ? targetChild.weeks
            : [];

          if (modified) {
            if (existingWeeks.length === 0) {
              existingWeeks = [update];
            }
            const mergedWeeks = applyUpdateToWeeks(existingWeeks, update);
            return {
              ...combo,
              children: combo.children.map((child) =>
                String(child?.id || child?.child_id) ===
                String(targetChild?.id || targetChild?.child_id)
                  ? {
                      ...child,
                      modified: modified || undefined,
                      weeks: mergedWeeks,
                    }
                  : child
              ),
            };
          } else {
            // creation phase
            existingWeeks = existingWeeks.filter(
              (w) => w.week_number !== update.week_number
            );
            const shouldAdd =
              update.responsible_for &&
              (update.pickup_time || update.dropoff_time);
            const mergedWeeks = shouldAdd
              ? [...existingWeeks, update]
              : existingWeeks;

            return {
              ...combo,
              children: combo.children.map((child) =>
                String(child?.id || child?.child_id) ===
                String(targetChild?.id || targetChild?.child_id)
                  ? { ...child, weeks: mergedWeeks }
                  : child
              ),
            };
          }
        })
      );
    }
  };

  useEffect(() => {
    // console.log("parentCombinationsV2",parentCombinationsV2)
    if (!parentCombinationsV2) return;
    const comboV2 = parentCombinationsV2.find(
      (c) => (c?.id || c?.coparent_combination_id) == activeComboId
    );
    if (!comboV2) return;
    let childV2 = null;
    if (sameScheduleForAll) {
      childV2 = comboV2.children?.[0];
    } else {
      childV2 = comboV2.children?.find(
        (c) => (c?.child_id || c?.id) == activeChildId
      );
    }
    // console.log("childV2",childV2)
    if (!childV2 || !Array.isArray(childV2.weeks)) return;

    // Find the correct week object
    const weekKey = index === 0 ? "week_number1" : "week_number2";
    const weekObj = childV2.weeks[0]?.[weekKey];
    // console.log("weekObj",weekObj)
    if (weekObj) {
      const responsible_for = weekObj.responsible_for;
      const pickup_time = weekObj.pickup_time;
      const dropoff_time = weekObj.dropoff_time;

      setWeekData({
        week_number: index === 0 ? 1 : 2,
        [`parent${index === 0 ? 1 : 2}_id`]:
          index === 0 ? parent1?.user_id : parent2?.user_id,
        assigned_to: index === 0 ? "parent1" : "parent2",
        responsible_for,
        pickup_time,
        dropoff_time,
      });

      // Reset and set form fields to ensure UI updates
      form.resetFields();
      const savedTime = pickup_time || dropoff_time;
      form.setFieldsValue({
        week: index === 0 ? 1 : 2,
        responsible_for,
        time: savedTime === null ? "Not setting a time" : savedTime,
      });
      setSelectedTime(savedTime === null ? "Not setting a time" : savedTime);
    }
    // eslint-disable-next-line
  }, []);
  // console.log("weekData",weekData)
  const renderTimeOptions = (selectedTime, onSelect) => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {timeOptions.map((option) => (
        <Tag.CheckableTag
          key={option}
          checked={selectedTime === option}
          onChange={() => onSelect(option)}
          style={{
            borderRadius: 8,
            padding: "4px 12px",
            backgroundColor: selectedTime === option ? "#f3e8ff" : "#f6f6f6",
            color: selectedTime === option ? "#9A4FE0" : "#000",
          }}
        >
          {option}
        </Tag.CheckableTag>
      ))}
      {/* If selectedTime is custom (not in list), show it as its own tag */}
      {selectedTime &&
        !timeOptions.includes(selectedTime) &&
        selectedTime !== "Not setting a time" && (
          <Tag.CheckableTag
            key="custom"
            checked
            onChange={() => onSelect(selectedTime)}
            style={{
              borderRadius: 8,
              padding: "4px 12px",
              backgroundColor: "#f3e8ff",
              color: "#9A4FE0",
            }}
          >
            {selectedTime}
          </Tag.CheckableTag>
        )}

      {customHour !== undefined && customMinute !== undefined && (
        <Tag.CheckableTag
          key="custom"
          checked={
            selectedTime ===
            `${String(customHour).padStart(2, "0")}:${String(
              customMinute
            ).padStart(2, "0")}`
          }
          onChange={() =>
            onSelect(
              `${String(customHour).padStart(2, "0")}:${String(
                customMinute
              ).padStart(2, "0")}`
            )
          }
          style={{
            borderRadius: 8,
            padding: "4px 12px",
            backgroundColor:
              selectedTime ===
              `${String(customHour).padStart(2, "0")}:${String(
                customMinute
              ).padStart(2, "0")}`
                ? "#f3e8ff"
                : "#f6f6f6",
            color:
              selectedTime ===
              `${String(customHour).padStart(2, "0")}:${String(
                customMinute
              ).padStart(2, "0")}`
                ? "#9A4FE0"
                : "#000",
          }}
        >
          {`${String(customHour).padStart(2, "0")}:${String(
            customMinute
          ).padStart(2, "0")}`}
        </Tag.CheckableTag>
      )}
      <Button
        type={showCustom ? "primary" : "dashed"}
        onClick={() => setShowCustom(!showCustom)}
      >
        Customize...
      </Button>
    </div>
  );

  return (
    <div>
      <Form form={form} layout="vertical" onValuesChange={onValuesChange}>
        {/* <Form.Item label="Week" name="week">
          <Select
            style={{ width: 220 }}
            value={weekData.week_number}
            defaultValue={weekData.week_number}
            disabled
            options={weekOptions}
          />
        </Form.Item> */}

        <Form.Item name="responsible_for" rules={[{ required: true }]}>
          <Radio.Group options={responsibleOptions} />
        </Form.Item>
        <Form.Item
          label={
            form.getFieldValue("responsible_for") === "pick_up"
              ? index === 0
                ? `Pick up time for ${
                    parent1?.nickname || parent1?.name || "Parent 1"
                  }`
                : `Pick up time for ${
                    parent2?.nickname || parent2?.name || "Parent 2"
                  }`
              : form.getFieldValue("responsible_for") === "drop_off"
              ? index === 0
                ? `Drop off time for ${
                    parent2?.nickname || parent2?.name || "Parent 2"
                  }`
                : `Drop off time for ${
                    parent1?.nickname || parent1?.name || "Parent 1"
                  }`
              : "Time"
          }
          name="time"
          rules={[{ required: true }]}
        >
          {renderTimeOptions(selectedTime, (val) => {
            setSelectedTime(val);
            form.setFieldsValue({ time: val });
            // Manually trigger onValuesChange with updated values
            onValuesChange(
              { time: val },
              { ...form.getFieldsValue(), time: val }
            );
          })}
          {showCustom && (
            <div
              style={{
                marginTop: 16,
                display: "flex",
                gap: 8,
                alignItems: "center",
              }}
            >
              <Select
                placeholder="HH"
                value={customHour}
                onChange={setCustomHour}
                style={{ width: 80 }}
              >
                {Array.from({ length: 24 }, (_, i) => (
                  <Select.Option key={i} value={i}>
                    {String(i).padStart(2, "0")}
                  </Select.Option>
                ))}
              </Select>
              <span>:</span>
              <Select
                placeholder="MM"
                value={customMinute}
                onChange={setCustomMinute}
                style={{ width: 80 }}
              >
                {[0, 15, 30, 45].map((i) => (
                  <Select.Option key={i} value={i}>
                    {String(i).padStart(2, "0")}
                  </Select.Option>
                ))}
              </Select>
              <Button
                type="primary"
                disabled={
                  customHour === undefined || customMinute === undefined
                }
                onClick={() => {
                  const customTime = `${String(customHour).padStart(
                    2,
                    "0"
                  )}:${String(customMinute).padStart(2, "0")}`;
                  setSelectedTime(customTime);
                  form.setFieldsValue({ time: customTime });
                  setShowCustom(false);
                  // Manually trigger onValuesChange with updated values
                  onValuesChange(
                    { time: customTime },
                    { ...form.getFieldsValue(), time: customTime }
                  );
                }}
              >
                Save
              </Button>
            </div>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};

export default AlternateWeeks;
